module.exports = require("@swa-ui/core/src/Heading/Heading.module.scss");